require('./bootstrap');

$('.numeric').on('keyup change', function () {
    var value = $(this).val();
    $(this).val(value.replace(/[^0-9]/g, ''));
});
